'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/src/components/common/ui/text/Title.jsx';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';
import Button from '@/src/components/common/ui/buttons/Button.jsx';
import getBlogDataJson from '@/public/json/blog/blog_list.json';
import BlogSingle from '@/src/components/common/ui/single-item/BlogSingle.jsx';
import BlogSingleMobile from '@/src/components/common/ui/single-item/BlogSingleMobile.jsx';
import { StyledBlogList } from '@/src/components/common/eco/sections/blog-list/blog-list.style.js';

const BlogList = ({ data, limit, id, allBlog }) => {
	const isMobile = useDeviceTypeMobile();

	const [blogData, setBlogData] = useState(allBlog ? allBlog : getBlogDataJson || []);

	const formatDate = (dateString) => {
		const months = [
			'January', 'February', 'March', 'April', 'May', 'June',
			'July', 'August', 'September', 'October', 'November', 'December',
		];
		if (!dateString) return { day: '', month: '', year: '' };

		const [year, month, day] = dateString.split('-').map(Number);
		const dateObj = new Date(Date.UTC(year, month - 1, day));

		return {
			day: dateObj.getUTCDate(),
			month: months[dateObj.getUTCMonth()],
			year: dateObj.getUTCFullYear(),
		};
	};

	const renderBlogItem = (e, index) => {
		const thumb = e?.images?.find((img) => img?.thumb === 'on');
		const { day, month, year } = formatDate(e?.data?.date);

		return (
			<Col md={4} key={index} className="blog-single-item-open ">
				<BlogSingle
					text={e?.data?.subtitle}
					title={e?.data?.title}
					link={`/events/${e?.data?.slug}`}
					img={thumb?.full_path || ''}
					day={day}
					month={month}
					year={year}
				/>
			</Col>
		);
	};

	const renderBlogItemMobile = (e, index) => {
		const thumb = e?.images?.find((img) => img?.thumb === 'on');
		const { day, month, year } = formatDate(e?.data?.date);

		return (
			<Col md={4} key={index} className="blog-single-item-open ">
				<BlogSingleMobile
					text={e?.data?.subtitle}
					title={e?.data?.title}
					link={`/events/${e?.data?.slug}`}
					img={thumb?.full_path || ''}
					day={day}
					month={month}
					year={year}
				/>
			</Col>
		);
	};

	const reloadHomePage = () => {
		window.location.href = '/news-and-events';
	};

	// Decide how many blogs to show based on limit or default 3
	const blogsToShow = limit ? blogData.slice(0, limit) : blogData.slice(0, 3);

	return (
		<StyledBlogList id={id} className="brandlist limit">
			<Container>
				<Row>
					{data?.section_data?.subtitle && (
						<Col md={12} className="d-flex justify-content-between">
							<Title tag="h2" margin="0 0 60px" text={data.section_data.subtitle} color="#fff" />
							{!isMobile && data?.section_data?.button_text && (
								<Button
									src={data.section_data.btn_link}
									hoverbackground="white"
									hoverColor="#101825"
									text={data.section_data.button_text}
								/>
							)}
						</Col>
					)}

					{!isMobile &&
						blogsToShow.map((e, index) => renderBlogItem(e, index))}

					{isMobile &&
						blogsToShow.map((e, index) => renderBlogItemMobile(e, index))}

					{isMobile && data?.section_data?.button_text && (
						<Button
							margin="30px 0 0"
							hoverbackground="white"
							hoverColor="#101825"
							src={data.section_data.btn_link}
							text={data.section_data.button_text}
						/>
					)}
				</Row>
			</Container>
		</StyledBlogList>
	);
};

export default BlogList;
